module.exports = __webpack_public_path__ + "img/icon-add-library.fcc96047.svg";